var image_viewer_rtlignore_default = {
  "fontElementMap": "Bi-hI",
  "imageFigure": "aEqun",
  "imageContainer": "vhG7C",
  "expandContainer": "HyH6O",
  "expandIcon": "aUSp4",
  "pointer": "yS7zq",
  "imageWrapper": "L2P8r",
  "imageRatio": "Ku1Gj",
  "image": "t-3Md",
  "imageOverlay": "fPPMO",
  "imagePreload": "p-aKh",
  "imageHighres": "udLMe",
  "onlyHighRes": "GJZpH",
  "image_loading": "KGsQy"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
